import React from "react";
import cls from "./ErrorMessage.module.less";

interface IErrorMessageProps {
  message: string;
}

const ErrorMessage = (props: IErrorMessageProps) => {
  const { message } = props;
  return <span className={cls.errorMessage}>{message}</span>;
};

export default ErrorMessage;
